const DB_NAME = 'rci_dapp';
const DB_VERSION = 3;
const DB_STORE_NAME = 'public_keys';
let db;
function openDb() {
    // console.log("openDb ...");
    var req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onsuccess = evt => {
        db = req.result;
        // console.log("openDb DONE");
    };
    req.onerror = evt => {
        // TODO
        // @ts-ignore
        console.error("openDb:", evt.target.errorCode);
    };
    req.onupgradeneeded = evt => {
        console.log("openDb.onupgradeneeded");
        // @ts-ignore
        let store = evt.currentTarget.result.createObjectStore(DB_STORE_NAME, {
            autoIncrement: false
        });
    };
}
/**
 * @param {string} store_name
 * @param {string} mode either "readonly" or "readwrite"
 */
function getObjectStore(store_name, mode) {
    var tx = db.transaction(store_name, mode);
    return tx.objectStore(store_name);
}
export function add(cid, obj) {
    let transaction = db.transaction([DB_STORE_NAME], 'readwrite');
    transaction.oncomplete = event => {
        // TODO?
        // console.log('Key stored!');
    };
    transaction.onerror = event => {
        // TODO - handle error
        console.error(event);
    };
    const store = transaction.objectStore(DB_STORE_NAME);
    store.add(obj, cid);
    // const request = store.add(key, cid);
    // request.onsuccess = event => {
    //     // event.target.result === customer.ssn;
    // };    
}
export async function get(cid) {
    const store = getObjectStore(DB_STORE_NAME, 'readonly');
    return new Promise((resolve, reject) => {
        const request = store.get(cid);
        request.onerror = event => {
            // TODO: Handle errors!
            reject();
        };
        request.onsuccess = event => {
            // console.log(`Key is ${event.target.result}`);
            // @ts-ignore
            resolve(event.target.result);
        };
    });
}
openDb();
